import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-[#faf5eb] text-slate-900 py-20 px-4 sm:px-6 lg:px-8" data-id="element-163">
      <div className="max-w-3xl mx-auto" data-id="element-164">
        <div className="flex items-center justify-center mb-8" data-id="element-165">
          <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center" data-id="element-166">
            <AlertTriangleIcon className="w-6 h-6 text-amber-600" data-id="element-167" />
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-slate-900" data-id="element-168">
          El problema no es cuánto ganas, es que eres un espectador de tu propio
          dinero.
        </h2>

        <div className="space-y-6 text-lg text-slate-700 leading-relaxed" data-id="element-169">
          <p data-id="element-170">
            En Latinoamérica, la inflación y los "gastos hormiga" son una trampa
            mortal. Apps de comida, suscripciones que no usas y pequeñas compras
            por impulso están desangrando tu cuenta bancaria sin que te des
            cuenta.
          </p>
          <p className="font-medium text-slate-900 text-xl border-l-4 border-amber-500 pl-6 py-2 bg-white/50 rounded-r-lg" data-id="element-171">
            Mirar tu app del banco hoy es como hacer una autopsia: solo sirve
            para ver cómo murió tu dinero, pero no para salvarlo.
          </p>
        </div>
      </div>
    </section>;
}